import PageTemplate from "../components/common/PageTemplate";
import CartDetailNew from "../screen/purchase/cart/CartDetailNew";

const CartDetailsPage = () => {
  return (
    <PageTemplate
      mainComponent={<CartDetailNew />}
      noPadding={true}
      logo={"Keranjang Belanja"}
    />
  );
};

export default CartDetailsPage;
